import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceRouter } from '@pershing/pershing-core';
import { TradingOrderStatusServiceDefinition } from '../../models/common/order-status-service-definition';
import { BehaviorSubject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class OrderStatusService {
    private orderStatusBaseUrl: string;
    private acctNumParam: string = 'urn:id:headers.x-AccountNumber';

    private onOrdersSubject = new BehaviorSubject<any | null>(null);
    private platform: string;
    onOrdersSubject$ = this.onOrdersSubject.asObservable();

    constructor(private http: HttpClient, private serviceRouter: ServiceRouter, @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings?.platform) {
            this.platform = appSettings.platform;
        } else {
            this.platform = 'professional';
        }
        this.orderStatusBaseUrl = this.serviceRouter.getServiceRouteURL(TradingOrderStatusServiceDefinition.getInstance(this.platform), 
        { ignoreOptions: { serviceVersion: true } });
    }

    private getHttpHeadersWithAcctNumOrGroupName(acctOrGroupNum: string, isGroup = false ) {
        let acctOrGroupKey = isGroup ? 'x-GroupName' : 'x-AccountNumber';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            [acctOrGroupKey]: acctOrGroupNum
        });

        return headers;
    }

    private convertJsonToParam(searchObj?: {}): HttpParams{
        if (searchObj) {
            let params = new HttpParams();
            for (let key in searchObj) {
                if (searchObj.hasOwnProperty(key)) {
                    let val = searchObj[key];
                    params = params.append(key, val);
                }
            }
            return params;
        }
    }

    // searchObj - { orderStatusCode: $value, securityType: $value }
    public getOrdersStatus(platform: string, acctNum: string, searchObj?: {}): void {
        let url = this.orderStatusBaseUrl + '/' + this.acctNumParam;
        if (searchObj) {
            let params = new HttpParams();
            for (let key in searchObj) {
                if (searchObj.hasOwnProperty(key)) {
                    let val = searchObj[key];
                    params = params.append(key, val);
                }
            }
            this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(acctNum), params: params }).subscribe(success => {
                this.onOrdersSubject.next(success);
            }, error => {
                this.onOrdersSubject.next(error);
            });
        } else {
            this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(acctNum) }).subscribe(success => {
                this.onOrdersSubject.next(success);
            }, error => {
                this.onOrdersSubject.next(error);
            });
        }
    }

    // endpoint for groups of accounts (/trading/orders/group/{groupName})
    public getOrdersStatusGroup(groupName: string, searchObj?: {}): void {
        let url = this.orderStatusBaseUrl + '/group/' + groupName;
        if (searchObj) {
            let params = this.convertJsonToParam(searchObj);
            this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(groupName, true), params: params }).subscribe(success => {
                this.onOrdersSubject.next(success);
            }, error => {
                this.onOrdersSubject.next(error);
            });
        } else {
            this.http.get(url, { headers: this.getHttpHeadersWithAcctNumOrGroupName(groupName, true) }).subscribe(success => {
                this.onOrdersSubject.next(success);
            }, error => {
                this.onOrdersSubject.next(error);
            });
        }
    }

}
